import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Layout, Space } from 'antd';
import styled from 'styled-components';

const { Footer } = Layout;

export const FooterWrapper = styled(Footer)`
  background: #fff;
  padding-inline: 72px;
  border-top: 1px solid #dfe2e6;
  min-height: 124px;
  direction: rtl;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ant-row {
    width: 100%;
  }

  @media screen and (max-width: 1025px) {
    padding-inline: 40px;
    justify-content: center;
    gap: 16px;

    .ant-col {
      width: 100% !important;
    }

    .ant-space {
      flex-wrap: wrap;
      gap: 8px 24px !important;
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    padding-inline: 15px;
    flex-direction: column;
    gap: 16px;
    min-height: auto;
    padding-block: 20px;

    .ant-col {
      width: 100% !important;
    }

    .ant-space {
      flex-wrap: wrap;
      gap: 8px 24px !important;
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }

  @media screen and (max-width: 620px) {
    padding-inline: 12px;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: 1px solid #dfe2e6;
  }

  .company-name {
    font-size: 20px;
    font-weight: ${FONT_WEIGHT.extremeBold};
    color: #1d2a6e;
    margin: 0;
  }

  @media (max-width: 1280px) {
    .company-name {
      font-size: 20px;
    }
  }

  @media screen and (max-width: 1025px) {
    gap: 8px;
    justify-content: center;
  }

  @media screen and (max-width: 768px) {
    justify-content: center;

    .company-name {
      font-size: 18px;
    }
  }
`;

export const ContactItem = styled(Space)`
  font-size: 16px;
  font-weight: ${FONT_WEIGHT.regular};

  .label {
    color: #ce6239;
  }

  .value {
    color: #1a295a;
  }
`;
